interface StatusBadgeProps {
  status: string;
}

const styles: Record<string, { wrap: string; dot: string }> = {
  active:   { wrap: "bg-safe-green/12 text-safe-green border-safe-green/30",         dot: "bg-safe-green" },
  ok:       { wrap: "bg-safe-green/12 text-safe-green border-safe-green/30",         dot: "bg-safe-green" },
  draft:    { wrap: "bg-surface-3 text-fg-muted border-line",                        dot: "bg-fg-muted" },
  inactive: { wrap: "bg-caution-amber/12 text-caution-amber border-caution-amber/30",dot: "bg-caution-amber" },
  error:    { wrap: "bg-block-red/12 text-block-red border-block-red/30",            dot: "bg-block-red" },
  blocked:  { wrap: "bg-block-red/12 text-block-red border-block-red/30",            dot: "bg-block-red" },
  cached:   { wrap: "bg-electric-blue/12 text-electric-blue border-electric-blue/30",dot: "bg-electric-blue" },
};

const fallback = { wrap: "bg-surface-3 text-fg-muted border-line", dot: "bg-fg-muted" };

export function StatusBadge({ status }: StatusBadgeProps) {
  const s = styles[status.toLowerCase()] ?? fallback;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-medium ${s.wrap}`}
    >
      <span aria-hidden="true" className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {status}
    </span>
  );
}
